// @ts-ignore
import createPersistedState from 'vuex-persistedstate';

export default createPersistedState({
    storage: window.sessionStorage,
    reducer: (vuexState) => {
        // sessionStorage储存除cache之外的所有信息
        let sessionState : any = Object.assign({}, vuexState);

        for (let key in sessionState) {
            if (key === 'cache') {
                delete sessionState[key];
            }
        }
        return sessionState
    }
});
